import { memo, useCallback } from 'react';
import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';
import { IconPhoto } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';


const MAX_FILE_SIZE_MB = 3;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const ImageUploadButton = () => {
  const { editor } = useRichTextEditorContext();

  const handleImageUpload = useCallback((event) => {
    const file = event.target.files?.[0];

    if (file) {
      // 1. Validar el tipo de archivo (ya lo tenías)
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';

      // 2. **Nueva Validación: Limite de Tamaño**
      const isSizeValid = file.size <= MAX_FILE_SIZE_BYTES;

      if (!isImage) {
        notifications.push('');
        // Opcional: limpiar el input para que pueda seleccionar el mismo archivo de nuevo
        notifications.show({
          title: "Error al carga imagen",
          message: "Solo se permiten imágenes PNG y JPEG.",
          color: "red",
        });
        event.target.value = null;
        return;
      }

      if (!isSizeValid) {

        // Opcional: limpiar el input para que pueda seleccionar el mismo archivo de nuevo
        notifications.show({
          title: "Error al carga imagen",
          message: `El archivo es demasiado grande. El tamaño máximo permitido es de ${MAX_FILE_SIZE_MB} MB.`,
          color: "red",
        });
        event.target.value = null;
        return;
      }

      // Si pasa ambas validaciones, procede a cargar la imagen
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Image = e.target?.result;
        if (base64Image && editor) {
          editor.chain().focus().setImage({ src: base64Image }).run();
        }
      };
      reader.readAsDataURL(file);
    }
  }, [editor]);

  return (
    <RichTextEditor.Control
      title="Upload image"
      aria-label="Upload image"
    >
      <input
        type="file"
        accept="image/png,image/jpeg"
        onChange={handleImageUpload}
        style={{ display: 'none' }}
        id="image-upload"
      />
      <label htmlFor="image-upload" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        <IconPhoto size={16} stroke={1.5} />
      </label>
    </RichTextEditor.Control>
  );
};

const RichTextEditorComponent = memo(function RichTextEditorComponent({ editor }) {
  return (
    <RichTextEditor editor={editor}>
      <RichTextEditor.Toolbar sticky stickyOffset="100px">
        <RichTextEditor.ControlsGroup>
          <RichTextEditor.Bold title="Negrita (*texto*)" />
          <RichTextEditor.Italic title="Cursiva (_texto_)" />
          <RichTextEditor.Strikethrough title="Tachado (~texto~)" />
          <RichTextEditor.Code title="Monoespaciado (`texto`)" />
          <RichTextEditor.ClearFormatting />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          <RichTextEditor.BulletList title="Lista con viñetas" />
          <ImageUploadButton />
        </RichTextEditor.ControlsGroup>

        <RichTextEditor.ControlsGroup>
          <RichTextEditor.Undo />
          <RichTextEditor.Redo />
        </RichTextEditor.ControlsGroup>
      </RichTextEditor.Toolbar>

      <RichTextEditor.Content />
    </RichTextEditor>
  );
});

export { RichTextEditorComponent };